module.exports = __webpack_public_path__ + "static/media/sim.d8ca1dc5.svg";